import {
    SET_AVAILABLE_SEARCH_TABS,
    HIDE_SNAP_ASSISTANT_REMINDER,
    SHOW_SNAP_ASSISTANT_REMINDER,
} from '../actions/actionsNamesList';

function getDefaultPageDataState() {
    const { ads = [] } = window.pageData;
    const shouldRenderReminder = ads.some(ad => ad === 'addExtension') && !ads.some(ad => ad === 'snapAssistant');

    return {
        searchString: '',
        searchResultsExist: {
            foodProfilesExists: true,
            placesExists: true,
            documentsExists: true
        },
        isSnapAssistantReminderShown: false,
        shouldRenderReminder,
    };
}

export default function pageStatus(state = getDefaultPageDataState(), action) {
    switch (action.type) {
        case SET_AVAILABLE_SEARCH_TABS: {
            return {
                ...state,
                searchResultsExist: action.data
            };
        }
        case SHOW_SNAP_ASSISTANT_REMINDER: {
            return {
                ...state,
                isSnapAssistantReminderShown: true,
            };
        }
        case HIDE_SNAP_ASSISTANT_REMINDER: {
            return {
                ...state,
                isSnapAssistantReminderShown: false,
            };
        }
        default: {
            return state;
        }
    }
}
